/**
 * Route Loading Fallback Component
 *
 * Displayed while lazy-loaded route components are being fetched and parsed
 */

export function RouteLoadingFallback(): JSX.Element {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="space-y-4 text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto" />
        <p className="text-sm text-muted-foreground">Loading page...</p>
      </div>
    </div>
  )
}
